import * as React from "react";
import PropTypes from "prop-types";

import { noop } from "lodash";
import classNames from "classnames";

import IconNavNext from "../../assets/img/svg/nav-next.svg";
import IconNavPrev from "../../assets/img/svg/nav-prev.svg";
import Icon from "./icon";

import "./SwiperButton.scss";

const SwiperButton = ({
  isFloating,
  className,
  swiperID,
  onClick,
  onMouseDown,
  buttonType,
  title,
  customIcon,
  ...otherProps
}) => {
  const content =
    customIcon || (buttonType === "next" ? IconNavNext : IconNavPrev);
  return (
    <button
      type="button"
      className={classNames(`swiper-button--${buttonType}`, className, {
        "swiper-button--floating": isFloating,
      })}
      tabIndex="0"
      id={buttonType}
      aria-label={title}
      aria-controls={swiperID}
      onClick={onClick}
      onMouseDown={onMouseDown}
      {...otherProps}
    >
      <Icon
        content={content}
        title={title}
        className="arrow-icon"
        aria-hidden="true"
        focusable="false"
      />
    </button>
  );
};

export default SwiperButton;

SwiperButton.defaultProps = {
  isFloating: false,
  className: "",
  onClick: noop,
  onMouseDown: noop,
  customIcon: null,
};

SwiperButton.propTypes = {
  isFloating: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  swiperID: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  buttonType: PropTypes.string.isRequired,
  customIcon: PropTypes.elementType,
};
